import { PALValues } from 'fitbeat.models';
import i18n from './i18n';

export const mappedPalDescriptions =  [
  {
    value: PALValues.NotActive,
    title: i18n.t('weightTarget:palNotActive'),
    description: i18n.t('weightTarget:palNotActiveDescription'),
  },
  {
    value: PALValues.ModeratelyActive,
    title: i18n.t('weightTarget:palModeratelyActive'),
    description: i18n.t('weightTarget:palModeratelyActiveDescription'),
  },
  {
    value: PALValues.HighlyActive,
    title: i18n.t('weightTarget:palHighlyActive'),
    description: i18n.t('weightTarget:palHighlyActiveDescription'),
  },
];
